<template>
  <span v-if="showSelectRole">
    <b-form-group
      v-if="!localDataLoad"
    >
      <b-form-select
        :key="optionsWithPlaceholder.length"
        v-model="role"
        :options="optionsWithPlaceholder"
        value-field="value"
        text-field="text"
        trim
        @change="handleRole"
      />
    </b-form-group>

    <b-spinner
      v-else
      label="Loading..."
    />
  </span>

</template>

<script>
export default {
  props: {
    showSelectRole: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const q = this.$route.query.role
    return {
      role: q !== undefined && q !== null && q !== '' ? q : '',
      localDataLoad: false,
    }
  },

  computed: {
    optionsRole() {
      return this.$store.getters['generalData/roles/roles']
    },
    optionsWithPlaceholder() {
      const roles = this.optionsRole || []
      const placeholder = { value: '', text: 'Select Role', disabled: true }
      return [placeholder, ...roles]
    },
  },

  watch: {
    /* eslint-disable */
    '$route.query.role'(val) {
      this.role = val !== undefined && val !== null && val !== '' ? val : ''
    },
  },
  async mounted() {
    if (this.showSelectRole) {
      if (!this.$store.getters['generalData/roles/roleLoaded']) {
        this.localDataLoad = true
        await this.$store.dispatch('generalData/roles/fetchRoles')
        this.localDataLoad = false
      }
    }
    // Ensure placeholder shows when no role in URL
    if (this.$route.query.role == null || this.$route.query.role === '') {
      this.role = ''
    }
  },
  methods: {
    handleRole() {
      this.$router.push({
        query: { ...this.$route.query, role: this.role },
      })
    },
  },
}
</script>
